import { useQuery } from 'components/RouterQuery';

interface ProductKnowledgeQAProps {
  msgId: string;
}

interface QueryValue {
  q: string;
  a: string;
}

export const ProductKnowledgeQA = (props: ProductKnowledgeQAProps) => {
  const { msgId } = props;

  const { q, a } = useQuery<QueryValue>();
  const qList = q?.split(',');
  const aList = a?.split(',');

  if (qList?.includes(msgId)) {
    return <div className="bg-[#FFF0F0] mt-2 w-6 h-6 text-center leading-6 text-[#F05B5B]">Q</div>;
  }

  if (aList?.includes(msgId)) {
    return <div className="bg-[#FFF0F0] mt-2 w-6 h-6 text-center leading-6 text-[#F05B5B]">A</div>;
  }

  return null;
};
